import React, { useEffect, useContext, useState } from "react";
import SettingBoxCalender from "./SettingBoxCalender";
import { Store } from "../../state/state";
import { toJS } from "mobx";
import SettingImage from "./SettingImage";
import SettingText from "./SettingText";
import SettingSelect from "./SettingSelect";

function SettingElse({ select }) {
  const store = useContext(Store);
  const [day, setDay] = useState(1);
  const [month, setMonth] = useState(1);
  const [index, setIndex] = useState(0);
  useEffect(() => {
    if (select.startsWith("col")) {
      let [, , monthNumber, dayNumber, indexI] = select.split("-");

      setDay(dayNumber - 1);
      setMonth(monthNumber - 1);
      setIndex(indexI);
    }
  }, [select]);
  if (select.startsWith("col"))
    return <SettingBoxCalender data={{ day, month, index }} />;

  if (select.startsWith("image")) return <SettingImage />;
  if (select === "h1" || select === "h2")
    return <SettingText select={select} />;
  return <SettingSelect select={select} />;
}

export default SettingElse;
